var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0.914271C40.5 0.409319 40.0812 0 39.5645 0H5.88554C5.36885 0 4.95001 0.409319 4.95001 0.914271V43.885C4.95001 44.39 5.36885 44.7993 5.88554 44.7993H32.0791C32.0793 44.7993 32.0797 44.7993 32.08 44.7993C32.3235 44.7993 32.5628 44.7063 32.7418 44.5315L40.226 37.2173C40.4049 37.0424 40.4977 36.8087 40.4978 36.5709H40.5V0.914271ZM32.0803 35.6566C31.5636 35.6566 31.1447 36.0659 31.1447 36.5709V42.9708H6.82106V1.82854H38.629V35.6566H32.0803ZM33.0158 41.6778V37.4851H37.3059L33.0158 41.6778Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5796 4.57135H10.0954V6.39989H17.5796V4.57135Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2572 7.31415H10.0954V9.14269H22.2572V7.31415Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4191 11.4284H11.0309C10.5142 11.4284 10.0954 11.8377 10.0954 12.3427V38.3994C10.0954 38.9044 10.5142 39.3137 11.0309 39.3137H27.8704V37.4851H18.9829V29.2567H33.4835V32.9142H35.3546V12.3427C35.3546 11.8377 34.9357 11.4284 34.4191 11.4284ZM33.4835 16.4569H18.9829V13.2569H33.4835V16.4569ZM18.9829 18.2854H33.4835V21.9425H18.9829V18.2854ZM17.1118 13.2569V16.4569H11.9664V13.2569H17.1118ZM11.9664 37.4851V18.2854H17.1118V37.4851H11.9664ZM18.9829 27.4282V23.7711H33.4835V27.4282H18.9829Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7086 19.6568H13.3698V21.4854H15.7086V19.6568Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7086 25.1425H13.3698V26.971H15.7086V25.1425Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7086 30.6281H13.3698V32.4566H15.7086V30.6281Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7086 34.2852H13.3698V36.1137H15.7086V34.2852Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.dd9985f40817414844d85af1c0669628.svg";
export { ForwardRef as ReactComponent };